
const mesh = async function(downloadPath: string): Promise<string> {
  const configPath = downloadPath
  const resp = await fetch(configPath);
  return await resp.text();
}

export default mesh